<template>
    <div class="OpenCard_header_Steps">
        <div class="reset-steps">
            <div class="reset_steps" v-for="(item, index) in step" :key="index">
                <div class="steps_con">
                    <img v-if="active >= index" :src="item.imgActive" alt="" />
                    <img v-else :src="item.img" alt="" />
                    <div class="steps_tit">
                        <span :class="active >= index ? 'lineActive' : ''">{{ item.title }}</span>
                    </div>
                </div>
                <span v-if="item.span" :class="active >= index + 1 ? 'lineActive' : ''"></span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        active: {
            type: [Number, String],
            required: true
        },
    },
    data() {
        return {
            step: [
                {
                    title: "填写信息",
                    img: require("@/assets/images/opencard/open11.png"),
                    imgActive: require("@/assets/images/opencard/open1.png"),
                    span: true,
                },
                {
                    title: "套餐详情",
                    img: require("@/assets/images/opencard/open22.png"),
                    imgActive: require("@/assets/images/opencard/open2.png"),
                    span: true,
                },
                {
                    title: "入网协议",
                    img: require("@/assets/images/opencard/open44.png"),
                    imgActive: require("@/assets/images/opencard/open4.png"),
                    span: true,
                },
                {
                    title: "实名认证",
                    img: require("@/assets/images/opencard/open33.png"),
                    imgActive: require("@/assets/images/opencard/open3.png"),
                },
            ],
        }
    },

    created() { },
    // 组件方法
    methods: {},

    computed: {},

    watch: {},

    mounted() { },
}
</script>

<style scoped lang='scss'>
.OpenCard_header_Steps {
    width: 100%;
    height: 66%;
    background: #ffffff;
    border-top-left-radius: px2rem(30);
    border-top-right-radius: px2rem(30);
    padding: px2rem(0) px2rem(20);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .reset-steps {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;

        :nth-child(4) {
            width: 16% !important;
        }

        .reset_steps {
            width: 28%;
            display: flex;
            justify-content: space-around;
            align-items: center;

            .steps_con {
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                align-items: center;

                img {
                    width: px2rem(60);
                    height: px2rem(60);
                }

                .steps_tit {
                    span {
                        font-size: px2rem(24);
                        background: #ffffff !important;
                    }
                }
            }

            span {
                margin-top: px2rem(-38);
                width: px2rem(84);
                height: px2rem(4);
                background-color: #c2cec8;
            }
        }

        .lineActive {
            background: #1e4b9f !important;
            color: #1e4b9f;
        }
    }
}
</style>